import luigi from "./images/luigi.jpeg";
import juli from "./images/juli.jpg";
import jess from "./images/jess.jpg";
import emi from "./images/emi.jpg";
import { useNavigate } from "react-router-dom";
import CardProfile from "./profile/CardProfile";

function QuienesSomos() {
  const navigate = useNavigate();

  const irADonaciones = () => {
    navigate("/perfil", { state: { section: "Donaciones" } });
  };

  const teamMembers = [
    {
      name: "Luis Pagola",
      role: "CEO",
      description:
        "Visionario y líder, impulsó múltiples apps al éxito: más de 50k descargas y 900 reseñas con 4.7 de puntuación. Apasionado por la innovación y el trabajo colaborativo.",
      imageUrl: luigi,
      socialLinks: {
        instagram: "https://www.instagram.com/luigipagola/",
        twitter: "https://x.com/luigipagola",
        linkedin:
          "https://www.linkedin.com/in/luis-adri%C3%A1n-pagola-guill%C3%A9n/",
      },
      objectPosition: "center top",
      objectPositionHover: "-3px 22px",
      scaleHover: 2.5,
    },
    {
      name: "Julián Pijuan",
      role: "Front-end Dev.",
      cardBg: "#D2EED5",
      bottomBg: "#7acf84",
      description:
        "Especialista en React y Tailwind CSS, crea interfaces responsivas y accesibles. Apasionado por el diseño limpio y la experiencia de usuario.",
      imageUrl: juli,
      socialLinks: {
        instagram: "https://www.instagram.com/julianpijuan/",
        twitter: "https://twitter.com/julianpijuan",
        linkedin: "https://www.linkedin.com/in/juliánpijuan",
      },
      objectPosition: "center top",
      objectPositionHover: "2px 5px",
      scaleHover: 1.4,
    },
    {
      name: "Jessica Núñez",
      role: "Project Manager",
      cardBg: "#D1E2F0",
      bottomBg: "#76a9d2",
      description:
        "Con más de 3 años como Project Manager y Full Stack Developer, coordina equipos multidisciplinarios para entregar proyectos a tiempo y con calidad.",
      imageUrl: jess,
      socialLinks: {
        instagram: "https://www.instagram.com/jessie_nu/",
        twitter: "https://twitter.com/jessicanunez",
        linkedin: "https://www.linkedin.com/in/jess-nu/",
      },
      objectPosition: "center top",
      objectPositionHover: "-10px 10px",
      scaleHover: 1.4,
    },
    {
      name: "Emiliano Etcheverry",
      cardBg: "#FBC6C6",
      bottomBg: "#f24a4a",
      role: "Full stack Dev.",
      description:
        "Apasionado por JavaScript y UI/UX, implementa animaciones y transiciones que mejoran la experiencia del usuario.",
      imageUrl: emi,
      socialLinks: {
        instagram: "https://www.instagram.com/emiliano.e.s/",
        twitter: "https:twitter.com/emilianoetcheverry",
        linkedin: "https://www.linkedin.com/in/emiliano-etcheverry",
      },
      objectPosition: "center top",
      objectPositionHover: "0px 3px",
      scaleHover: 2,
    },
  ];

  return (
    <div className="flex flex-col items-center h-full w-full pb-12">
      <div className="bg-secondary w-full flex flex-col gap-16 items-center justify-center h-full">
        <h2 className="font-main px-[10dvw] pt-20 text-center text-white font-semibold sm:text-5xl ta:text-6xl text-7xl">
          Quiénes somos y nuestra misión
        </h2>
        <div className="flex flex-col text-center gap-12 text-white px-[15dvw]">
          <p className="font-main font-medium sm:text-base ta:text-lg text-xl ">
            En BuscaTuAmigo sabemos lo que significa perder a una mascota: es un
            integrante de la familia, un compañero de vida, un verdadero amigo.
            Y cuando desaparece, se siente un vacío enorme, lleno de
            incertidumbre y angustia.
          </p>
          <p className="font-main font-medium sm:text-base ta:text-lg text-xl ">
            Este proyecto nació justamente de esa experiencia, de entender ese
            dolor y transformarlo en una herramienta de ayuda. Sabemos lo
            difícil que es, en medio de los nervios y la fragilidad, ponerse a
            diseñar un cartel, buscar cómo difundirlo o pensar en cada detalle
            técnico. En esos momentos no deberías preocuparte por eso: deberías
            enfocarte en lo más importante, reencontrarte con tu amigo.
          </p>
          <p className="font-main font-medium sm:text-base ta:text-lg text-xl ">
            Por eso creamos BuscaTuAmigo: un espacio que te acompaña en ese
            camino. Detrás de cada aviso, de cada búsqueda y de cada adopción,
            está el deseo profundo de que ninguna mascota quede lejos de su
            familia. Más que una página, queremos ser un puente: entre quienes
            buscan, quienes ayudan y quienes esperan. Porque detrás de cada
            mascota perdida hay una historia, una familia y un amigo que quiere
            volver a su hogar.
          </p>
        </div>
      </div>
      <div className="h-full w-full">
        <img src="/wave.svg" alt="Wave" className="w-full h-auto" />
      </div>

      <div className="w-full pt-12 sm:pt-8 px-0">
        <div className="w-full flex flex-col gap-16 sm:gap-0 items-center justify-center sm:mt-0 mt-12">
          <h2 className="font-main font-semibold sm:text-5xl ta:text-6xl text-7xl sm:pb-4 pb-14">
            Nuestro Equipo
          </h2>
          <div className="w-full">
            <div className="grid gap-4 [grid-template-columns:repeat(auto-fit,minmax(320px,1fr))] justify-items-center">
              {teamMembers.map((member, idx) => (
                <CardProfile key={idx} {...member} />
              ))}
            </div>
          </div>
        </div>

        <div className=" p-8 sm:px-0 flex flex-col gap-24 sm:gap-12 justify-center items-center sm:pt-12 pt-36">
          <h2 className="font-main text-gray-800 text-center font-semibold sm:text-4xl text-5xl">
            En memoria de nuestra inspiración
          </h2>
          <div className="border-[8px] overflow-hidden rounded-2xl mx-[10dvh] sm:mx-2 border-secondary">
            <img src="./honores.jpg" alt="Wave Invert" className=" w-[650px]" />
          </div>
        </div>

        <div className="flex flex-col gap-7 text-gray-800 p-8 items-center justify-center text-center">
          <h2 className="text-4xl font-semibold font-main">
            ¿Quieres apoyar el proyecto?
          </h2>
          <p className="text-gray-700 font-main font-medium text-base  max-w-xl mx-auto">
            Tu ayuda nos permite seguir conectando a mascotas perdidas con sus
            familias, mejorar nuestras herramientas y llegar a más personas que
            lo necesitan.
          </p>
          <button
            onClick={irADonaciones}
            className="w-fit h-[60px] bg-secondary hover:bg-orange-700 text-white font-main font-medium py-3 px-6 rounded-lg shadow-lg transition-transform transform hover:scale-105 inline-block"
          >
            Ir a Donaciones
          </button>
        </div>
      </div>
    </div>
  );
}

export default QuienesSomos;
